import { FormEvent, useState } from 'react';
import { CellarFormData, Cellar } from '../types';

interface CellarFormProps {
  cellarForm: CellarFormData;
  setCellarForm: (form: CellarFormData) => void;
  editingCellar?: Cellar | null;
  onSubmit: (e: FormEvent) => void;
  onDelete?: () => void;
  onClose: () => void;
}

export function CellarForm({ cellarForm, setCellarForm, editingCellar, onSubmit, onDelete, onClose }: CellarFormProps) {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteConfirmText, setDeleteConfirmText] = useState('');

  const isEditing = !!editingCellar;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className="ios-sheet w-full"
        onClick={e => e.stopPropagation()}
      >
        <div className="ios-sheet-handle" />

        {/* Header */}
        <div style={{ 
          padding: '0 20px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--color-wine)',
              fontSize: '16px',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          <h2 className="wine-title" style={{ 
            fontSize: '18px', 
            margin: 0,
            color: 'var(--color-text)'
          }}>
            {isEditing ? 'Edit Cellar' : 'New Cellar'}
          </h2>
          <div style={{ width: '50px' }} />
        </div>

        <form onSubmit={onSubmit} style={{ padding: '0 20px 20px' }}>
          <div style={{ marginBottom: '16px' }}>
            <label className="ios-label">Cellar Name</label>
            <input
              type="text"
              value={cellarForm.name}
              onChange={(e) => setCellarForm({ ...cellarForm, name: e.target.value })}
              placeholder="e.g. Home Cellar, Beach House"
              className="ios-input"
              required
            />
          </div>
          
          <div style={{ marginBottom: '24px' }}>
            <label className="ios-label">Description (optional)</label>
            <textarea
              value={cellarForm.description}
              onChange={(e) => setCellarForm({ ...cellarForm, description: e.target.value })}
              placeholder="A note about this cellar..."
              className="ios-input"
              style={{ resize: 'none' }}
              rows={2}
            />
          </div>
          
          <button
            type="submit"
            className="ios-btn ios-btn-primary w-full"
          >
            {isEditing ? 'Save Changes' : 'Create Cellar'}
          </button>
          
          {isEditing && onDelete && (
            <>
              {!showDeleteConfirm ? (
                <button
                  type="button"
                  onClick={() => setShowDeleteConfirm(true)}
                  className="ios-btn w-full"
                  style={{ 
                    background: '#fee2e2', 
                    color: '#991b1b',
                    marginTop: '12px'
                  }}
                >
                  Delete Cellar
                </button>
              ) : (
                <div className="ios-card" style={{ 
                  marginTop: '16px', 
                  padding: '16px',
                  background: '#fef2f2'
                }}>
                  <p style={{ 
                    fontSize: '14px', 
                    color: '#991b1b',
                    marginBottom: '12px'
                  }}>
                    This will permanently delete this cellar and all its wines. Type <strong>{editingCellar.name}</strong> to confirm.
                  </p>
                  <input
                    type="text"
                    value={deleteConfirmText}
                    onChange={(e) => setDeleteConfirmText(e.target.value)}
                    placeholder={`Type "${editingCellar.name}"`}
                    className="ios-input"
                    style={{ borderColor: '#fca5a5', marginBottom: '12px' }}
                  />
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                      type="button"
                      onClick={() => { setShowDeleteConfirm(false); setDeleteConfirmText(''); }}
                      className="ios-btn ios-btn-secondary"
                      style={{ flex: 1 }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={onDelete}
                      disabled={deleteConfirmText !== editingCellar.name}
                      className="ios-btn"
                      style={{ 
                        flex: 1,
                        background: '#dc2626',
                        color: 'white',
                        opacity: deleteConfirmText !== editingCellar.name ? 0.5 : 1
                      }}
                    >
                      Delete Forever
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </form>
      </div>
    </div>
  );
}
